<!--
 * @Author: WLL
 * @Date: 2020-04-14 12:08:48
 * @LastEditors: WLL
 * @LastEditTime: 2020-05-09 16:19:22
 * @Description: 机构关注行业
 -->
<template>
  <div class="industry">
    <div class="industry_above horizontal_container">
      <SjCard class="horizontal_item" v-sj-loading="industryChartLoading">
        <div class="industry_chart_wrapper">
          <div class="industry_chart_titleBox">
            <span class="industry_chart_title">机构关注行业Top10</span>
            <SjAutoComplete
              class="industry_chart_select"
              v-model="industryTimeRangeSelected"
              :options="industryTimeRangeList"
              @click.native="onFilterClick('机构关注行业top10时间')"
              @change="onIndustryTimeRangeChange"
            ></SjAutoComplete>
          </div>
          <div class="industry_chart">
            <Chart
              @click="onIndustryChartClick"
              :options="industryChartOptions"
            ></Chart>
          </div>
        </div>
      </SjCard>
      <SjCard class="horizontal_item" v-sj-loading="conceptChartLoading">
        <div class="industry_chart_wrapper">
          <div class="industry_chart_titleBox">
            <span class="industry_chart_title">机构关注概念板块Top10</span>
            <SjAutoComplete
              class="industry_chart_select"
              v-model="conceptTimeRangeSelected"
              @click.native="onFilterClick('机构关注概念板块top10时间')"
              :options="industryTimeRangeList"
              @change="onConceptTimeRangeChange"
            ></SjAutoComplete>
          </div>
          <div class="industry_chart">
            <Chart
              @click="onConceptChartClick"
              :options="conceptChartOptions"
            ></Chart>
          </div>
        </div>
      </SjCard>
    </div>
    <div class="industry_below horizontal_container">
      <SjCard class="horizontal_item" v-sj-loading="industryTableLoading">
        <display-area
          title="机构关注行业"
          iconClass="icon_xh iconhuiyijiyao"
          iconSize="18px"
          iconColor="#399BFF"
          :showMore="false"
        >
          <common-table
            :data="industryTableData"
            :columns="industryTableColumns"
            :tableProps="industryTableProps"
            :scrollDisabled="
              industryTotalPage !== 0 && industryTotalPage < industryPageNo
            "
            @infiniteScroll="getMoreIndustryTableData"
            @cell-click="industryReportClickWrapper"
          ></common-table>
        </display-area>
      </SjCard>
      <SjCard class="horizontal_item" v-sj-loading="conceptTableLoading">
        <display-area
          title="机构关注概念板块"
          :showMore="false"
          iconClass="icon_xh iconhuiyijiyao"
          iconSize="18px"
          iconColor="#f3a709"
        >
          <common-table
            :data="conceptTableData"
            :columns="conceptTableColumns"
            :tableProps="conceptTableProps"
            :scrollDisabled="
              conceptTotalPage !== 0 && conceptTotalPage < conceptPageNo
            "
            @infiniteScroll="getMoreConceptTableData"
            @cell-click="conceptReportClickWrapper"
          ></common-table>
        </display-area>
      </SjCard>
    </div>
  </div>
</template>

<script>
import Chart from "@/components/Chart";
import { industryTimeRangeList } from "@/utils/const";
import reportMixin from "@/views/mixins/reportMixin";
import CommonTable from "@/components/CommonTable/index";
import DisplayArea from "@/components/DisplayArea";

export default {
  mixins: [reportMixin],
  components: {
    DisplayArea,
    CommonTable,
    Chart
  },
  data() {
    return {
      industryTimeRangeList,

      industryTimeRangeSelected: 1,
      industryChartData: [],
      industryChartLoading: false,
      industryTableData: [],
      industryTableColumns: [
        {
          prop: "PUBLISHDATE",
          center: true,
          label: "日期",
          width: 80,
          formatter: this.publishDateFormatter
        },
        {
          prop: "PUBLISHNAME",
          label: "行业",
          center: true,
          width: 100,
          customRender: this.ellipsisRender
        },
        {
          prop: "REPORTTITLE",
          label: "标题",
          customRender: this.ellipsisRender
        },
        {
          prop: "COMPANYNAME",
          label: "机构",
          center: true,
          width: 80,
          customRender: this.agencyRender
        },
        {
          prop: "ALLRESEARCHER",
          label: "作者",
          center: true,
          width: 100,
          customRender: this.researcherRender
        },
        {
          prop: "EMRATINGNAME",
          label: "评级",
          center: true,
          width: 50
        }
      ],
      industryTableProps: {},
      industryTableLoading: false,
      industryTablePublishName: null,
      conceptablePublishName: null,
      industryPageNo: 1,
      industryPageSize: 40,
      industryTotalPage: 0,

      conceptTimeRangeSelected: 1,
      conceptChartData: [],
      conceptChartLoading: false,
      conceptTableData: [],
      conceptTableColumns: [
        {
          prop: "PUBLISHDATE",
          label: "日期",
          center: true,
          width: 80,
          formatter: this.publishDateFormatter
        },
        {
          prop: "PUBLISHNAME",
          label: "概念板块",
          center: true,
          width: 100
        },
        {
          prop: "REPORTTITLE",
          label: "标题",
          customRender: this.ellipsisRender
        },
        {
          prop: "COMPANYNAME",
          label: "机构",
          center: true,
          width: 80,
          customRender: this.agencyRender
        },
        {
          prop: "ALLRESEARCHER",
          center: true,
          label: "作者",
          width: 100,
          customRender: this.researcherRender
        },
        {
          prop: "EMRATINGNAME",
          label: "评级",
          center: true,
          width: 60
        }
      ],
      conceptTableProps: {},
      conceptTableLoading: false,
      conceptPageNo: 1,
      conceptPageSize: 40,
      conceptTotalPage: 0,

      industryThrottlingCount: 0,
      conceptThrottlingCount: 0
    };
  },
  computed: {
    industryChartOptions() {
      const { industryChartData } = this;
      return {
        tooltip: {
          formatter: params => {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.industryThrottlingCount++;
            if (this.industryThrottlingCount % 50 === 0) {
              window.sendEvent("view_chart", {
                chart_name: "机构关注行业柱状图",
                upstream_page_title: "首页"
              });
            }
            const data = params[0];
            return `${data.axisValueLabel}<br/>${data.marker}${data.value}`;
          }
        },
        grid: {
          left: 50,
          bottom: 80,
          containLabel: false
        },
        yAxis: {
          minInterval: 1,
          boundaryGap: [0, 0.1]
        },
        xAxis: {
          data: industryChartData.map(v => v.PUBLISHNAME)
        },
        series: [
          {
            type: "bar",
            itemStyle: {
              color: "#399bff"
            },
            barMaxWidth: 16,
            label: {
              show: true,
              position: "top"
            },
            data: industryChartData.map(v => v.RPT_SUM)
          }
        ]
      };
    },
    conceptChartOptions() {
      const { conceptChartData } = this;
      return {
        tooltip: {
          formatter: params => {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.conceptThrottlingCount++;
            if (this.conceptThrottlingCount % 50 === 0) {
              window.sendEvent("view_chart", {
                chart_name: "机构关注概念板块柱状图",
                upstream_page_title: "首页"
              });
            }
            const data = params[0];
            return `${data.axisValueLabel}<br/>${data.marker}${data.value}`;
          }
        },
        grid: {
          left: 70,
          bottom: 80,
          containLabel: false
        },
        xAxis: {
          data: conceptChartData.map(v => v.PUBLISHNAME)
        },
        yAxis: {
          minInterval: 1,
          boundaryGap: [0, 0.1]
        },
        series: [
          {
            type: "bar",
            itemStyle: {
              color: "#399bff"
            },
            barMaxWidth: 16,
            label: {
              show: true,
              position: "top"
            },
            data: conceptChartData.map(v => v.RPT_SUM)
          }
        ]
      };
    }
  },
  created() {
    this.init();
  },
  methods: {
    onConceptChartClick(data) {
      this.conceptablePublishName = data.name;
      this.getConceptTableData();
    },
    onIndustryChartClick(data) {
      this.industryTablePublishName = data.name;
      this.getIndustryTableData();
    },
    init() {
      this.industryTablePublishName = null;
      this.onIndustryTimeRangeChange();
      this.onConceptTimeRangeChange();
    },
    onFilterClick(first_screening, second_screening = "") {
      window.sendEvent("click_filter", {
        page_type: "关注行业",
        first_screening: first_screening,
        second_screening: second_screening
      });
    },
    industryReportClickWrapper(params) {
      this.onReportClick(params, {
        upstream_page_type: "机构关注行业",
        upstream_page_modular: "机构关注行业Top10"
      });
    },
    conceptReportClickWrapper(params) {
      this.onReportClick(params, {
        upstream_page_type: "机构关注行业",
        upstream_page_modular: "机构关注概念板块Top10"
      });
    },
    onIndustryTimeRangeChange() {
      this.getIndustryChartData();
      this.getIndustryTableData();
    },
    async getIndustryChartData() {
      try {
        this.industryChartLoading = true;
        this.industryChartData = [];
        const { data } = await this.$apis.Industry.getIndustryChart({
          V_MONTH: this.industryTimeRangeSelected,
          V_INDSORT: "011"
        });
        const dataFinal = [];
        data.forEach(v => {
          if (v.V_INDSORT === "011") {
            dataFinal.push(v);
          }
        });
        this.industryChartData = dataFinal;
      } finally {
        this.industryChartLoading = false;
      }
    },
    async getIndustryTableData() {
      this.industryPageNo = 1;
      this.industryTotalPage = 0;
      this.industryTableData = [];
      this.getMoreIndustryTableData(true);
    },
    async getMoreIndustryTableData(init = false) {
      try {
        this.industryTableLoading = true;
        const params = {
          pageNo: this.industryPageNo,
          pageSize: this.industryPageSize,
          V_MONTH: this.industryTimeRangeSelected,
          V_PUBLISHNAME: this.industryTablePublishName,
          V_INDUCODE_H: "011"
        };
        const { data, page } = await this.$apis.Industry.getIndustryList(
          params
        );
        this.industryPageNo += 1;
        this.industryTotalPage = page.totalPage;
        if (init) {
          this.industryTableData = data;
        } else {
          data.forEach(v => {
            this.industryTableData.push(v);
          });
        }
      } finally {
        this.industryTableLoading = false;
      }
    },
    onConceptTimeRangeChange() {
      this.getConceptChartData();
      this.getConceptTableData();
    },
    async getConceptChartData() {
      try {
        this.conceptChartLoading = true;
        this.conceptChartData = [];
        const { data } = await this.$apis.Industry.getConceptChart({
          V_MONTH: this.conceptTimeRangeSelected
        });
        this.conceptChartData = data.splice(0, 10);
      } finally {
        this.conceptChartLoading = false;
      }
    },
    async getConceptTableData() {
      this.conceptPageNo = 1;
      this.conceptTotalPage = 0;
      this.conceptTableData = [];
      this.getMoreConceptTableData(true);
    },
    async getMoreConceptTableData(init = false) {
      try {
        this.conceptTableLoading = true;
        const params = {
          pageNo: this.conceptPageNo,
          pageSize: this.conceptPageSize,
          V_PUBLISHNAME: this.conceptablePublishName,
          V_MONTH: this.conceptTimeRangeSelected
        };
        const { data, page } = await this.$apis.Industry.getConceptList(params);
        this.conceptPageNo += 1;
        this.conceptTotalPage = page.totalPage;
        if (init) {
          this.conceptTableData = data;
        } else {
          data.forEach(v => {
            this.conceptTableData.push(v);
          });
        }
      } finally {
        this.conceptTableLoading = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
@above-height: 270px;

.industry {
  box-sizing: border-box;
  padding: 10px;
  display: flex;
  flex-direction: column;
  .industry_above {
    height: @above-height;
    margin-bottom: 10px;

    .industry_chart_wrapper {
      height: 100%;
      display: flex;
      flex-direction: column;
      .industry_chart_titleBox {
        display: flex;
        align-items: center;
        padding: 6px 10px;
        .industry_chart_title {
          .text("body", "dark");
          margin-right: 10px;
        }
        .industry_chart_select {
          width: 170px;
        }
      }
      .industry_chart {
        flex: 1;
        min-height: 0;
        padding: 0 5px;
        box-sizing: border-box;
      }
    }
  }
  .industry_below {
    flex: 1;
    min-height: 0;
  }
}
</style>
